import { AbstractControl } from '@angular/forms';

export type ServerFieldError = {
  field: string;
  code: string;
  message: string;
};

export const SERVER_FIELD_ELEMENT_IDS: Record<string, string> = {
  'residence.addressLine1': 'cac-residence-addressLine1',
  'residence.addressLine2': 'cac-residence-addressLine2',
  'residence.city': 'cac-residence-city',
  'residence.userState': 'cac-residence-userState',
  'residence.zipCode': 'cac-residence-zipCode',
  'residence.monthResiding': 'cac-residence-monthResiding',
  'residence.ownedBy': 'cac-residence-ownedBy',
  'personal.firstName': 'cac-personal-firstName',
  'personal.lastName': 'cac-personal-lastName',
  'personal.email': 'cac-personal-email',
  'personal.dateOfBirth': 'cac-personal-date-of-birth',
  'personal.phone': 'cac-personal-phone',
  'identification.ssn': 'cac-identification-ssn',
  'income.employerName': 'cac-income-employerName',
  'income.employerPhone': 'cac-income-employerPhone',
  'income.biWeeklyPay': 'cac-income-biWeeklyPay',
  'income.hireDate': 'hireDate',
  'income.incomeType': 'cac-income-div-error-incomeType',
  'income.secondary.employerName': 'cac-secondary-income-employerName',
  'income.secondary.employerPhone': 'cac-income-s_employerPhone',
  'income.secondary.biWeeklyPay': 'cac-sf-income-biWeeklyPay',
  'income.secondary.hireDate': 'cac-sf-hireDate',
  'income.secondary.incomeType': 'cac-income-div-error-sf-incomeType',
};

const SECTION_SCROLL_TARGETS: Record<string, string> = {
  residence: '#residence-content',
  personal: '#personal-content',
  income: '#income-content',
  identification: '#cac-identification-div',
};

export function formErrorsForServerField(
  error: ServerFieldError
): Record<string, true> {
  if (error.field === 'residence.addressLine1' && error.code === 'NotNull') {
    return { streetNumberError: true };
  }
  if (error.code === 'Size') {
    return { maxLength: true };
  }
  if (error.code === 'NotNull') {
    return { isNotEmpty: true };
  }
  return { serverError: true };
}

export function scrollToServerField(field: string): void {
  const id = SERVER_FIELD_ELEMENT_IDS[field];
  if (id) {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  const section = field.split('.')[0];
  const sectionSelector = SECTION_SCROLL_TARGETS[section];
  if (sectionSelector) {
    document
      .querySelector(sectionSelector)
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

export function applyServerFieldErrorsToGroup(
  errors: ServerFieldError[],
  prefix: string,
  getControl: (controlName: string) => AbstractControl | null
): void {
  const prefixWithDot = prefix.endsWith('.') ? prefix : `${prefix}.`;
  for (const error of errors) {
    if (!error.field.startsWith(prefixWithDot)) {
      continue;
    }
    const controlName = error.field.slice(prefixWithDot.length);
    if (controlName.includes('.')) {
      continue;
    }
    const control = getControl(controlName);
    if (!control) {
      continue;
    }
    control.setErrors(formErrorsForServerField(error));
    control.markAsTouched();
  }
}

export function isCapsValidationFailure(result?: {
  errorType?: string;
  fieldErrors?: ServerFieldError[] | null;
}): boolean {
  return (
    result?.errorType === 'validation' &&
    Array.isArray(result.fieldErrors) &&
    result.fieldErrors.length > 0
  );
}
